import React, { useState } from "react";
import { supabase } from "../supabase/client";
import {
  FiSettings,
  FiLock,
  FiMail,
  FiCheckCircle,
  FiAlertCircle,
} from "react-icons/fi";
import "./Settings.css";

const Settings = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState({ text: "", type: "" });
  const [loading, setLoading] = useState(false);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email);

    if (error) {
      setMessage({ text: error.message, type: "error" });
    } else {
      setMessage({
        text: `Password reset link sent to ${email}`,
        type: "success",
      });
      setEmail("");
    }
    setLoading(false);
  };

  return (
    <div className="settings-container">
      <div className="page-header">
        <h2 className="page-title">
          <FiSettings /> Settings
        </h2>
      </div>

      <div className="settings-card">
        <div className="settings-section">
          <h3 className="section-title">
            <FiLock /> Password Reset
          </h3>
          <p className="section-description">
            Enter your email to receive a password reset link.
          </p>

          <form onSubmit={handlePasswordReset} className="settings-form">
            <div className="form-group">
              <label className="form-label">
                <FiMail className="input-icon" />
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="form-input"
                required
              />
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
          </form>

          {message.text && (
            <div className={`message ${message.type}`}>
              {message.type === "success" ? (
                <FiCheckCircle className="message-icon" />
              ) : (
                <FiAlertCircle className="message-icon" />
              )}
              <span>{message.text}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;
